module.exports = __webpack_public_path__ + "img/paper-plane-solid.56611ebb.svg";